import React from 'react';
import bg from "../../Assets/img/bg.jpg";
import blogImg from './../../Assets/img/blog.jpg'
import {Helmet} from "react-helmet";

const Blogs = () => {

    const blogs = [
        {
            img: blogImg,
            link: '/residential-trash-removal',
            date: '24 February 2020',
            title: 'Industries Trash Removal',
            text: 'Mega Season Removal does Residential Trash Removal services around Los Angeles County & San Fernando Valley.'
        },
        {
            img: blogImg,
            link: '/yard-clean-up',
            date: '24 February 2020',
            title: 'Industries Clean Up',
            text: 'Mega Season Removal does Residential Trash Removal services around Los Angeles County & San Fernando Valley.'
        },
        {
            img: blogImg,
            link: '/general-clean-up',
            date: '24 February 2020',
            title: 'Commercial Clean Up',
            text: 'Mega Season Removal does Residential Trash Removal services around Los Angeles County & San Fernando Valley.'
        },
        {
            img: blogImg,
            link: '/hills-clean-up',
            date: '24 February 2020',
            title: 'Residential Clean Up',
            text: 'Mega Season Removal does Residential Trash Removal services around Los Angeles County & San Fernando Valley.'
        },
        {
            img: blogImg,
            link: '/construction-trash-removal',
            date: '24 February 2020',
            title: 'Construction Trash Removal',
            text: 'Mega Season Removal does Residential Trash Removal services around Los Angeles County & San Fernando Valley.'
        },
        {
            img: blogImg,
            link: '/commercial-trash-removal',
            date: '24 February 2020',
            title: 'Commercial Trash Removal',
            text: 'Mega Season Removal does Residential Trash Removal services around Los Angeles County & San Fernando Valley.'
        },
    ]

    return (
        <>
            <Helmet>
                <title>Blog | Mega Dumpster Bin Rental - Best Company That Lets You Clean & Remove Trash & Rubbish</title>
            </Helmet>
            <section>
                <div className="container-fluid g-0">
                    <div className="page-banner">
                        <img src={bg} className="img-fluid" alt="About Us"/>
                        <div className="overly"/>
                        <div className="content">
                            <h1 className="display-1 text-white text-uppercase">BLOG</h1>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 py-5"><h1
                            className="text-center text-uppercase display-4">NEWS BLOG</h1><h3
                            className="text-center text-uppercase display-6 theme-color">Latest news from our blog</h3>
                        </div>
                    </div>
                    <div className="row">
                        {blogs.map((blog, index)=>(
                            <div className="col-md-4 my-5">
                                <div className="home-blog">
                                    <img src={blog.img} className="img-thumbnail" alt="blog"/>
                                    <p className="my-2"><small>{blog.date}</small></p>
                                    <a href="/residential-trash-removal">
                                        <h4>{blog.title}</h4>
                                    </a>
                                    <p>{blog.text}
                                        <a href="/residential-trash-removal">
                                            <button className="btn btn-sm btn-outline-success ms-2">Read More</button>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        ))}


                    </div>
                </div>
            </section>
        </>

    );
};

export default Blogs;
